import { Flex } from "@/common/styles";
import styled, { css } from "styled-components";
import { COLOR_MODE } from ".";

const progressColors = {
  default: { done: "#1787B8", inProgress: "#FF8500", background: "#D8D8D8" },
  goob: { background: "#003549", inProgress: "#FF8500", done: "#93BE00" },
};

const intakeInProgress = css`
  .intake {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].inProgress};
  }
`;
const intakeDone = css`
  .intake {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].done};
  }
`;
const bookingInProgress = css`
  ${intakeDone};
  .booking {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].inProgress};
  }
`;
const bookingDone = css`
  ${intakeDone};
  .booking {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].done};
  }
`;
const housingAssignmentInProgress = css`
  ${bookingDone};
  .housing-assignment {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].inProgress};
  }
`;
const housingAssignmentDone = css`
  ${bookingDone};
  .housing-assignment {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].done};
  }
`;
const medicalAssessmentInProgress = css`
  ${housingAssignmentDone};
  .medical-assessment {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].inProgress};
  }
`;
const medicalAssessmentDone = css`
  ${housingAssignmentDone};
  .medical-assessment {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].done};
  }
`;
const propertyDetailsInProgress = css`
  ${medicalAssessmentDone};
  .property {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].inProgress};
  }
`;
const propertyDetailsDone = css`
  ${medicalAssessmentDone};
  .property {
    background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].done};
  }
`;

export const InmateProgressContainer = styled.div``;

export const ProgressBar = styled(Flex)`
  margin: 5px 0;
  gap: 4px;

  ${({ step = 0 }) => {
    switch (step) {
      case 0:
        break;
      case 1:
        return intakeInProgress;
      case 2:
      case 3:
        return intakeDone;
      case 4:
        return bookingInProgress;
      case 5:
      case 6:
        return bookingDone;
      case 7:
        return housingAssignmentInProgress;
      case 8:
      case 9:
        return housingAssignmentDone;
      case 10:
        return medicalAssessmentInProgress;
      case 11:
      case 12:
        return medicalAssessmentDone;
      case 13:
        return propertyDetailsInProgress;
      case 14:
      case 15:
        return propertyDetailsDone;
    }
  }}
`;

export const ProgressBarItem = styled.div`
  flex-basis: 20%;
  background: ${({ colorMode = COLOR_MODE.DEFAULT }) => progressColors[colorMode].background};
  border-radius: 3px;
  height: 5px;
`;
